import {prepareFont} from '@assets/config/fonts/fonts';
import {LIGHT_MODE} from '@assets/const/liveChat';
import {THEME_CLOUD, THEME_MIDNIGHT} from '@assets/const/themeSetting';
import convertHexToRgba from '@assets/helpers/utils/convertHexToRgba';
import isColor from '@assets/helpers/utils/isColor';
import isColorLight from '@functions/helpers/color/isColorLight';
import updateRootStyles from '../utils/updateRootStyles';

/**
 * @param {App.WidgetSetting} settings
 * @returns {App.WidgetSetting}
 */
export function prepareDefaultColors(settings) {
  let {brandColor, actionColor, textColor, btnPopupColor} = settings;
  if (!isColor(brandColor)) brandColor = '#FFFFFF';
  if (!isColor(actionColor)) actionColor = '#FFFFFF';
  if (!isColor(textColor)) textColor = '#FFFFFF';
  if (!isColor(btnPopupColor)) btnPopupColor = '#ffffff';
  return {...settings, brandColor, actionColor, textColor, btnPopupColor};
}

/**
 * @param {App.WidgetSetting} settings
 */
export function assignThemeColors(settings) {
  const {
    brandColor,
    actionColor,
    textColor,
    btnPopupColor,
    contentTextFont,
    floatBtnLabelColor,
    gradientColorOne,
    gradientColorSecond,
    isGradient
  } = prepareDefaultColors(settings);

  const isLightMode = settings.colorMode === LIGHT_MODE;
  const isCloudTheme = settings.theme === 'cloud';
  const bgHeader = isGradient ? gradientColorOne : brandColor;

  const getBgColorNav = () => {
    if (!settings.theme) return bgHeader;
    if (!isLightMode && (settings.theme === THEME_MIDNIGHT || settings.theme === THEME_CLOUD))
      return '#ffffff';
    switch (settings.theme) {
      case THEME_CLOUD:
      case THEME_MIDNIGHT:
        return '#303030';
      default:
        return bgHeader;
    }
  };
  const getTextColorNav = () => {
    if (!settings.theme) return actionColor;
    if (!isLightMode && (settings.theme === THEME_MIDNIGHT || settings.theme === THEME_CLOUD))
      return '#303030';
    switch (settings.theme) {
      case THEME_CLOUD:
      case THEME_MIDNIGHT:
        return '#ffffff';
      default:
        return actionColor;
    }
  };

  const variableWithThemeMode = {
    faqsThemeMode: settings.colorMode,
    faqsIconColor: isLightMode ? '#5C5F62' : '#DDDDDD',
    faqsNavigationColor: isLightMode ? '#A4A4A4' : '#979797',
    faqsBgColor: isLightMode ? '#F8F8F8' : '#0E0E0E',
    faqsBorderColor: isLightMode ? '#EBEBEB' : '#4F4F4F'
  };
  const textColorNavigation = getBgColorNav();
  const webLinkColorNavigation = isColorLight(textColorNavigation, 140) ? '#0000EE' : '#6BB8FF';

  const variables = {
    faqsGradientColorOne: gradientColorOne,
    faqsGradientColorSecond: gradientColorSecond,
    faqsBrandColor: bgHeader,
    faqsTextColor: textColor,
    faqsActionColor: actionColor,
    faqsBtnPopupColor: btnPopupColor,
    faqsFloatBtnLabelColor: floatBtnLabelColor,
    faqsContentTextFont: prepareFont(contentTextFont),
    faqsBackGroundItem: isCloudTheme ? '#3030300D' : convertHexToRgba(bgHeader, 0.08),
    faqsTextColorSecondary: convertHexToRgba(textColor, 0.7),
    faqsTextColorNavigation: textColorNavigation,
    faqsWebLinkColorNavigation: webLinkColorNavigation,
    faqsActionColorBtn: getTextColorNav(),
    ...variableWithThemeMode
  };
  const cssRules = Object.fromEntries(
    Object.entries(variables).map(([key, value]) => [`--${key}`, value])
  );
  updateRootStyles(cssRules);
  // Object.keys(variables).forEach(key => {
  //   document.documentElement.style.setProperty(`--${key}`, variables[key]);
  // });
}
